import type { ErrorEvent } from "@sentry/react";

const CHUNK_LOAD_ERROR_PATTERN =
  /Importing a module script failed|Unable to preload|Failed to fetch dynamically imported module|error loading dynamically imported module/i;

/**
 * Whether an event is a dynamic-import or code-split chunk load failure.
 *
 * These are dominated by transient network and in-app-webview fetch failures of
 * chunks that still exist at origin, so they aren't fixable in code. A sustained
 * spike still signals a broken deploy, which is why they're kept rather than
 * dropped.
 */
export const isChunkLoadError = (event: ErrorEvent): boolean =>
  event.exception?.values?.some(
    (value) =>
      CHUNK_LOAD_ERROR_PATTERN.test(value?.value || "") ||
      CHUNK_LOAD_ERROR_PATTERN.test(value?.type || ""),
  ) ?? false;
